import { Estimate } from "./estimate";
import { EstimateType } from "./estimate-type";
import { LaborOperation } from "./labor-operation";

export class LaborEstimate extends Estimate {
    constructor() {
        super(EstimateType.Labor);
    }
    
    public laborOperation: LaborOperation = new LaborOperation();
    public rate: number = 0.0;
    public hours: number = 0;
    public taxPercentage: number = 0.0;
    public description: string = "";
    public override get total(): number { return this.rate * this.hours; }
}